import React, { useState, useEffect } from 'react';
import * as IdKey from 'short-uuid';
import {
    Grid,
    TextField,
    FormControl,
    Typography,
    InputLabel,
    FormHelperText,
    Select,
    MenuItem
} from '@material-ui/core';
import "./editorStyle.css"

import { createPosition, getProfilePosition } from '../../actions/position-actions';
import MUIEditor, { MUIEditorState } from 'react-mui-draft-wysiwyg';
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import ModalConfirm from '../../utils/form/modalConfirmBase';
import ConfirmDialog from "../../utils/form/confirmDialog";
import { convertToRaw, convertFromRaw } from 'draft-js';
import { rawContent } from '../../../src/actions/dummy-actions';
import { getMaestras } from '../../actions/maestras-actions';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ColorButton, BorderGreenButton, BorderRedButton } from "../../utils/form/buttonsForm";
import { styles } from '../styles';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import TitleCase from "react-title-case";
import { titleCase } from "title-case";
import * as yup from "yup";
import _ from 'lodash';
import { REQUIRED_MESSAGE } from "../../constants";
import { useStateValue } from "../../context/store";

const editorConfig = {};

const CreatePosition = (props) => {
    const classes = styles();
    const { id } = props.match.params;
    //const isId = id;
    const [editorState, setEditorState] = useState(
        MUIEditorState.createWithContent(
            editorConfig,
            convertFromRaw(rawContent)
            )
        );

    const initialState =
        {
            rolePosition: null,
            immediateBoss: null,
            chargesUnderSupervision: [],
            location: null,
            attribute: '',
            chargeMission: null,
            nameProfilePosition: '',
            creationUser: 'Developer'
        }
    ;

    //const [openEditConfirm, setOpenEditConfirm] = useState(false);
    const [resetForm, setResetForm] = useState(false);
    const [charges, setCharges] = useState([]);
    const [location, setLocation] = useState([]);
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const [informationPosition, setInformationPosition] = useState(initialState);
    const [{filterProfile}, dispatch] = useStateValue();
    const [inputsValidation, setInputsValidation] = useState(() => {
        let values = {};
        for (const prop in informationPosition) {
            values[prop] = false;
        }
        return values;
    });
    const [maestras, setMaestras] = useState({
        jefeInmediato: [],
        motivoRetiro: [],
        motivoSolicitud: [],
        rolDecargo: [],
        tipoContrato: [],
    });

    const [confirm, setConfirm] = useState({
        open: false,
        question: "",
        handleClickOut: () => {},
        handleClick: () => {},
      });
      const [message, setMessage] = useState({
        description : '',
        textButtonSubmit : '',
        handleClick : () => {} ,
        handleClickOut : () => {},
        oneButtons : false,
        type : '',
        open : false
    })

      const closeModal = () => {
        setConfirm((anterior) => ({
          ...anterior,
          open: false,
        }));
      };

      const handleClickOut = () => props.history.push('/dashboard/perfil-cargos')
      const handleClickClose = () => {setMessage({...message, open: false}); setSubmitDisabled(false)}

      const cancelConfirm = () => {
          const create = "¿Está seguro que NO desea continuar creando el registro?"
          setMessage({
            description : create,
            textButtonSubmit : 'Aceptar',
            handleClick : () => handleClickOut(),
            handleClickOut: () => handleClickClose(),
            type : 'WARNING',
            open : true
        })
      };


    const onChangeValue = (newState) => setEditorState(newState);

    const onChangeGeneral = (e) => {
        const { name, value } = e.target;
        setInformationPosition({ ...informationPosition, [name]: value });
    };


    useEffect(() => {
        const getListCharges = async () => {
            const response = await getProfilePosition('ACTIVO');
            setCharges(_.sortBy(response?.data?.chargeList, [function(o) { return  o.denomination; }]));

        };
        getListCharges();

        const getListaLocations = async () => {
            const response = await getMaestras();
            setLocation(_.sortBy(response?.data?.maestras?.ubicaciones, [function(o) { return o }]));
        };
        getListaLocations();

        const getListaMaestras = async () => {
            const response = await getMaestras();
            setMaestras(response?.data?.maestras);
        };
        getListaMaestras();

        dispatch({
            type: "SET_BREADCRUMB",
            breadCrumbText: "Cargos   |   Cargos  >  Perfil de Cargos",
            breadCrumbSubText: "Perfil de Cargos",
            index: 6,
          });
    }, [resetForm]);

    const onClickSave = (data) => {
        const newData = {...data,
                    attribute: JSON.stringify(convertToRaw(editorState.getCurrentContent())),
                    creationUser: 'Developer',
                    chargesUnderSupervision: informationPosition.chargesUnderSupervision.map(function (item) {
                    return item['id'];}),
                }
        const create = "¿Está seguro que desea crear el registro? ";
        setMessage({
            description : create,
            textButtonSubmit : 'Aceptar',
            handleClick : () => handleClick(newData),
            handleClickOut: () => handleClickClose(),
            type : 'WARNING',
            open : true
        })

    };

    const handleClick = (data) => {
        setSubmitDisabled(true)
        setMessage({...message, open: false});
        setConfirm({...confirm, disabled: true});
        closeModal();
        setTimeout(() => {
            const create = async () => {
                const response = await createPosition(data);
                if (response?.status === 200 || response?.status === 201) {
                    setMessage({
                        description : `Perfil creado exitosamente`,
                        textButtonSubmit : 'Aceptar',
                        handleClick : () => handleClickOut() ,
                        oneButtons : true,
                        type : 'SUCCESS',
                        open : true
                    })
                } else if (response?.status > 399 && response?.status !== 401 && response?.status !==403) {
                    setMessage({
                        description : response?.data?.detail
                        ? response?.data?.detail : `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
                        textButtonSubmit : 'ACEPTAR',
                        handleClick : () => handleClickClose() ,
                        oneButtons : true,
                        type : 'WARNING',
                        open : true
                    })
                } else {
                    setMessage({
                        description : response?.data?.detail
                        ? response?.data?.detail : `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
                        textButtonSubmit : 'ACEPTAR',
                        handleClick : () => handleClickClose() ,
                        oneButtons : true,
                        type : 'WARNING',
                        open : true
                    })
                }
            };
            create();
        }, 2000);


    };

    const schema = yup.object().shape({
        nameProfilePosition: yup.string().nullable().required(REQUIRED_MESSAGE),
        rolePosition: yup.string().nullable().required(REQUIRED_MESSAGE),
        location: yup.string().nullable().required(REQUIRED_MESSAGE),
        chargeMission: yup.string().nullable().required(REQUIRED_MESSAGE).min(5, 'Ingrese mínimo 5 caracteres').max(250, 'Ingrese máximo 250 caracteres'),
        immediateBoss: yup.string().nullable().required(REQUIRED_MESSAGE),
        // chargesUnderSupervision: informationPosition.chargesUnderSupervision.length >= 0 ? null : yup.string().nullable().required("Ingrese mínimo un cargo"),
    });

      const { register, handleSubmit, control,  errors, reset, setValue, } = useForm({
        resolver: yupResolver(schema),
        mode: "onTouched",
        reValidateMode: "onChange",
      });


      const btnClear = () => {
          setResetForm(!resetForm);
          setValue("nameProfilePosition", "")
          setValue("rolePosition", "")
          setValue("location", "")
          setValue("chargeMission", "")
          setValue("immediateBoss", "")
          setValue("chargesUnderSupervision", [])
        reset({initialState});
        setEditorState( MUIEditorState.createWithContent(
            editorConfig,
            convertFromRaw(rawContent)
        ))
        setInformationPosition({...informationPosition, chargesUnderSupervision:[]})
    }

    return (
        <>
            <ConfirmDialog
                open={confirm.open}
                body={confirm.question}
                handleClickOut={confirm.handleClickOut}
                handleClick={confirm.handleClick}
            />

            <form style={{
                    width: 'auto',
                    marginTop: '20px',
                    marginRight: '15px',
                    marginLeft: '15px',
                }}
                onSubmit={handleSubmit(onClickSave)}
            >
                <Typography component='h1' variant='h4' style={{textAlign:'center'}}>
                        <div className={classes.iconCreate}>
                        <NoteAddIcon fontSize="large" />
                        &nbsp;Crear perfil
                    </div>
                </Typography>

                <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={4}>
                <FormControl variant="outlined" fullWidth  size="small"  error={!!errors.hasOwnProperty('nameProfilePosition') && errors['nameProfilePosition'].message} >
                  <InputLabel htmlFor="outlined-select-nameProfilePosition"  size="small">Perfil del cargo</InputLabel>
                  <Controller
                  control={control}
                   inputRef={register}
                   className = {classes.dropdown}
                   label="Perfil del cargo"
                   defaultValue=''

                    name="nameProfilePosition"
                    as={
                    <Select >
                          {charges.map((x) => (
                           <MenuItem
                           className={classes.menuItem}
                           key={IdKey.generate()}
                           value={ x.id}
                         >
                           { x.denomination}
                         </MenuItem>
                            )
                          )}
                    </Select>
                  }/>
                  <FormHelperText >{errors.hasOwnProperty('nameProfilePosition') && errors['nameProfilePosition'].message}</FormHelperText>
                </FormControl>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <FormControl variant="outlined" fullWidth  size="small"  error={!!errors.hasOwnProperty('rolePosition') && errors['rolePosition'].message} >
                  <InputLabel htmlFor="outlined-select-rolePosition"  size="small">Rol del cargo</InputLabel>
                  <Controller
                  control={control}
                   fullWidth
                   className = {classes.dropdown}
                   inputRef={register}
                   label="Rol del cargo"
                   onChange={onChangeGeneral}
                   defaultValue=''
                    as={
                    <Select >
                        {(_.sortBy(maestras?.rolDecargo, [function(o) { return o; }])).map((x) => (
                            <MenuItem
                                className={classes.menuItem}
                                key={IdKey.generate()}
                                value={ x}
                            >
                                { x}
                            </MenuItem>
                        ))}
                    </Select>
                   }
                   name="rolePosition"
                   inputProps={{
                       name: "rolePosition",
                       id: 'outlined-select-"rolePosition"',
                   }}
                    />
                  <FormHelperText >{errors.hasOwnProperty('rolePosition') && errors['rolePosition'].message}</FormHelperText>
                </FormControl>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <FormControl variant="outlined" fullWidth  size="small"  error={!!errors.hasOwnProperty('location') && errors['location'].message} >
                  <InputLabel htmlFor="outlined-select-location"  size="small">Ubicación</InputLabel>
                  <Controller
                  control={control}
                   fullWidth
                   className = {classes.dropdown}
                   label="Ubicación"
                   defaultValue=''
                   onChange={onChangeGeneral}
                   name="location"
                   inputProps={{
                       name: "location",
                       id: 'outlined-select-"location"',
                   }}
                    as={
                    <Select
                    name="location"
                    inputRef={register}>
                        {location.map((x) => (
                            <MenuItem
                                className={classes.menuItem}
                                key={IdKey.generate()}
                                value={ x}
                            >
                                { x}
                            </MenuItem>
                        ))}
                    </Select>
                   }/>
                  <FormHelperText >{errors.hasOwnProperty('location') && errors['location'].message}</FormHelperText>
                </FormControl>
                        </Grid>
                <Grid item xs={12} md={6} lg={4}>
                <FormControl variant="outlined" fullWidth  size="small"  error={!!errors.hasOwnProperty('immediateBoss') && errors['immediateBoss'].message} >
                  <InputLabel htmlFor="outlined-select-immediateBoss"  size="small">Jefe inmediato</InputLabel>
                  <Controller
                  control={control}
                   fullWidth
                   className = {classes.dropdown}
                   inputRef={register}
                   label="Jefe inmediato"
                   name="immediateBoss"
                   defaultValue=''
                    as={
                    <Select
                    >
                        {(_.sortBy(charges, (o) => o.denomination )).map((x) => (
                            <MenuItem
                                className={classes.menuItem}
                                key={IdKey.generate()}
                                value={ x.id}
                            >
                                <TitleCase string={ x.denomination} />
                            </MenuItem>
                        ))}
                    </Select>
                   }
                    />
                  <FormHelperText >{errors.hasOwnProperty('immediateBoss') && errors['immediateBoss'].message}</FormHelperText>
                </FormControl>
                        <FormControl fullWidth style={{ marginTop: 15 }}>
                            <Autocomplete
                                multiple
                                name="chargesUnderSupervision"
                                value={informationPosition.chargesUnderSupervision}
                                options={charges}
                                className = {classes.dropdownMultiple}
                                onChange={(e, newval, reason) => {
                                    setInformationPosition({...informationPosition, chargesUnderSupervision:newval});
                                }}
                                error={inputsValidation.chargesUnderSupervision}
                                getOptionLabel={(option) => titleCase(option.denomination)}
                                renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="outlined"
                                        inputRef={register}
                                        // onChange={onChangeGeneral}
                                        name="chargesUnderSupervision"
                                        label="Cargos bajo supervisión"
                                        placeholder="Empleado ABC"
                                        // error={informationPosition.chargesUnderSupervision.length <= 0 ? errors.hasOwnProperty('chargesUnderSupervision') && errors['chargesUnderSupervision'].message : ''}
                                    />

                                )}
                            />
                             {/* <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                                {informationPosition.chargesUnderSupervision.length <= 0 ? errors.hasOwnProperty('chargesUnderSupervision') &&
                                 errors['chargesUnderSupervision'].message : ''}
                            </FormHelperText> */}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={8}>
                        <FormControl fullWidth>
                            <TextField
                                fullWidth
                                inputRef={register}
                                variant="outlined"
                                label="Misión del cargo"
                                multiline
                                className = {classes.dropdownMultiple}
                                defaultValue=''
                                onChange={onChangeGeneral}
                                rows={4}
                                rowsMax={4}
                                name="chargeMission"
                                error={errors.hasOwnProperty('chargeMission') && errors['chargeMission'].message}
                            />
                            <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                                {errors.hasOwnProperty("chargeMission") &&
                                errors["chargeMission"].message}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12} lg={12} className="editor">
                        <MUIEditor
                            editorState={editorState}
                            name="texteditorControl"
                            config={editorConfig}
                            onChange={onChangeValue}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={3} style={{flexFlow: 'row-reverse'}}>
                    <Grid item xs={12} sm={6}>
                    <BorderRedButton onClick={cancelConfirm}>CANCELAR</BorderRedButton>&nbsp;&nbsp;
                    <ColorButton  type="submit" disabled={submitDisabled}>FINALIZAR</ColorButton>&nbsp;&nbsp;
                    <BorderGreenButton onClick={btnClear} >LIMPIAR</BorderGreenButton>&nbsp;&nbsp;
                    <ModalConfirm
                        description = { message.description }
                        textButtonSubmit = { message.textButtonSubmit }
                        handleClick = { message.handleClick }
                        handleClickOut = { message.handleClickOut }
                        oneButtons = { message.oneButtons }
                        type = { message.type }
                        open = { message.open }
                    />
                    </Grid>
                </Grid>
            </form>
        </>
    );
};

export default CreatePosition;
